export enum DialogType {
  ALERT = "alert",
  CONFIRM = "confirm",
  PROMPT = "prompt",
}

export enum DialogTheme {
  DANGER = "danger",
  DEFAULT = "default",
  SOCIAL = "social",
}
